import { render, staticRenderFns } from "./RateDetailStorageIndex.vue?vue&type=template&id=660eaf92&scoped=true&"
import script from "./RateDetailStorageIndex.vue?vue&type=script&lang=js&"
export * from "./RateDetailStorageIndex.vue?vue&type=script&lang=js&"
import style0 from "./RateDetailStorageIndex.vue?vue&type=style&index=0&id=660eaf92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660eaf92",
  null
  
)

export default component.exports